import * as React from 'react'
import { SVGProps } from 'react'
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m3 18 3.77-3.77c.782-.782 1.173-1.173 1.624-1.322A2 2 0 0 1 9.62 12.9c.454.143.85.528 1.643 1.297l3.224 3.13m7.014.361-1.425-1.424c-.792-.792-1.188-1.188-1.645-1.337a2 2 0 0 0-1.235 0c-.457.149-.853.545-1.646 1.337l-1.063 1.063M18.5 21.34l-4.014-4.014M18 8a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm-6.4 14h.8c3.36 0 5.04 0 6.324-.654a6 6 0 0 0 2.622-2.622C22 17.44 22 15.76 22 12.4v-.8c0-3.36 0-5.04-.654-6.324a6 6 0 0 0-2.622-2.622C17.44 2 15.76 2 12.4 2h-.8c-3.36 0-5.04 0-6.324.654a6 6 0 0 0-2.622 2.622C2 6.56 2 8.24 2 11.6v.8c0 3.36 0 5.04.654 6.324a6 6 0 0 0 2.622 2.622C6.56 22 8.24 22 11.6 22Z"
    />
  </svg>
)
export default SvgComponent
